import { render, staticRenderFns } from "./ModelTwo.vue?vue&type=template&id=9358eab8&scoped=true&"
import script from "./ModelTwo.vue?vue&type=script&lang=js&"
export * from "./ModelTwo.vue?vue&type=script&lang=js&"
import style0 from "./ModelTwo.vue?vue&type=style&index=0&id=9358eab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9358eab8",
  null
  
)

export default component.exports